import React from 'react';
import { t } from "../../../../../dev/helpers/translator";
import Keyboard from "../../../components/virtualKeyboard";

export default function enterbetid () {
    const { hidden = true } = this.props;
    return (
        <div hidden={hidden} className='betSlip-id-check'>
            {
                (() => {
                    return this.props.ui.showVirtualKeyBoard
                        ? <Keyboard settings={this.keyboardSettings} bindToElement={false} /> : (null);
                })()
            }
            <div className="single-form-item submit-betslip">
                <span onClick={this.betIdClick} ref={this.betIdInput}>{ this.state.betId || t("Enter booking ID...")}</span>
            </div>
            <div><button className='button-submit-betslip-id' type='button' onClick={this.onSubmit} disabled={this.state.betId.length <= 7}>{t(`Submit`)}</button></div>
            <span className='error-message-wrong-bet-id' hidden={this.state.betId.length >= 1}>{t(this.state.errMsg)}</span>
        </div>
    );
}

